"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.variants = void 0;

var _variant = require("@styled-system/variant");

var _styledComponents = require("styled-components");

var TYPOGRAPHY_BASE_CSS = (0, _styledComponents.css)(["font-size:var(--font-size-min);@media ", "{font-size:var(--font-size-max);}@supports(font-size:clamp(1rem,1rem,1rem)){font-size:clamp( var(--font-size-min,1rem),calc(1rem + var(--font-size-target,2vw)),var(--font-size-max,1.3rem) );}min-height:0vh;font-family:var(--font-family);font-weight:var(--font-weight);text-transform:var(--text-transform);line-height:var(--line-height,1);letter-spacing:var(--letter-spacing);@media ", "{letter-spacing:var(--letter-spacing-desktop,var(--letter-spacing));}"], function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.theme.queries.desktopAndUp;
});
var typography = {
  baseCSS: TYPOGRAPHY_BASE_CSS,
  title: {
    '--font-family': '"Space Grotesk", sans-serif',
    '--font-size-min': "".concat(51 / 16, "rem"),
    '--font-size-max': "".concat(85 / 16, "rem"),
    '--font-size-target': '5.5vw',
    '--font-weight': '500',
    '--text-transform': 'none',
    '--letter-spacing-desktop': '-4.25px',
    '--letter-spacing': '-2.55px',
    '--line-height': '1'
  },
  heading: {
    '--font-family': '"Space Grotesk", sans-serif',
    '--font-size-min': "".concat(26 / 16, "rem"),
    '--font-size-max': "".concat(38 / 16, "rem"),
    '--font-weight': '500',
    '--text-transform': 'none',
    '--letter-spacing': '-1.3px',
    '--letter-spacing-desktop': '-1.9px',
    '--line-height': '1.2'
  },
  subheading: {
    '--font-family': '"Space Grotesk", sans-serif',
    '--font-size-min': "".concat(16 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-size-max': "".concat(22 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-weight': '500',
    '--text-transform': 'none',
    '--letter-spacing': '-0.4px',
    '--letter-spacing-desktop': '-0.55px',
    '--line-height': '1.45'
  },
  header4: {
    '--font-family': '"Space Grotesk", sans-serif',
    '--font-size-min': '1rem',
    // TODO': get actual design system font sizes.
    '--font-size-max': '1.5rem',
    // TODO': get actual design system font sizes.
    '--font-weight': '600',
    '--text-transform': 'none'
  },
  caption: {
    '--font-family': '"Space Grotesk", sans-serif',
    '--font-size-min': "".concat(14 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-size-max': "".concat(14 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-weight': '600',
    '--text-transform': 'uppercase'
  },
  paragraph: {
    '--font-family': '"Exo 2", sans-serif',
    '--font-size-min': "".concat(17 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-size-max': "".concat(17 / 16, "rem"),
    // TODO': get actual design system font sizes.
    '--font-weight': '400',
    '--text-transform': 'none',
    '--letter-spacing': '-0.08px',
    '--letter-spacing-desktop': '-0.09px',
    '--line-height': '1.5'
  }
};
var variants = (0, _variant.variant)({
  variants: typography
});
exports.variants = variants;
var _default = typography;
exports["default"] = _default;